<template>
    <div class="section-title">
        <div class="section-title__header">
            <h4 class="section-title__text">{{ title }}</h4>
            <span v-if="subtitle" class="section-title__subtitle">{{ subtitle }}</span>
        </div>
        <div class="section-title__content">
            <slot />
        </div>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  title: {
    type: String,
    default: ''
  },
  subtitle: {
    type: String,
    default: ''
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.section-title {
    &__header {
        display: flex;
        align-items: baseline;
        justify-content: space-between;
        gap: 0.16rem;
        margin-bottom: 0.2rem;
    }

    &__text {
        font-size: 0.3rem;
        font-weight: 600;
        color: #333;
        margin: 0;
        line-height: 1.4;
    }

    &__subtitle {
        font-size: 0.24rem;
        font-weight: 400;
        color: #999;
        line-height: 1.4;
    }

    &__content {
        // 内容区域样式由 slot 内容决定
    }
}
</style>
